import React from 'react'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormHelperText from '@material-ui/core/FormHelperText'


const renderRadioButton = ({input, helperText, labelsAndValuesList, meta: {touched, invalid, error}, ...rest}) => (
    <FormControl error={invalid}>
        <RadioGroup {...input} {...rest}>
            {labelsAndValuesList.map(item => (
                <FormControlLabel key={item.value} value={item.value} control={<Radio/>} label={item.label}/>
            ))}
        </RadioGroup>
        {((invalid && error) || helperText) && <FormHelperText>{(invalid && error) || helperText}</FormHelperText>}
    </FormControl>
)

export default renderRadioButton